import { Link } from '@change-corgi/design-system-legacy/components/actions';
import { Box } from '@change-corgi/design-system-legacy/layout';

type Props = {
	responses: Array<{ id: string; decisionMaker: { id: string } }>;
	slug: string;
	trackReadResponseClick: (responseId: string) => void;
};

export function ReadResponse({ responses, slug, trackReadResponseClick }: Props): React.JSX.Element | null {
	if (responses.length === 0) return null;

	const firstDmResponseId = responses[0].id;
	const firstDmResponseUrl = `/p/${slug}/responses/${firstDmResponseId}`;

	return (
		<Box>
			<Link
				data-testid="read-response"
				data-qa="read-response"
				onClick={() => trackReadResponseClick(firstDmResponseId)}
				to={firstDmResponseUrl}
				target="_blank"
			>
				Read Response
			</Link>
		</Box>
	);
}
